<template>
  <div>
    <div class="blocks" v-if="twilioStatus === null">
      <div class="pt-3 l-m-b-20 align-items-center d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <h1 class="w-full">Phone numbers</h1>
          <div class="input-group search">
            <button type="button" class="btn input-group-btn" @click="clearSearch">
              <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
            </button>
            <input class="form-control" type="text" v-model="q" @keyup="searchText($event)"
                   placeholder="Search"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="blocks" v-else-if="twilioStatus === 'active'">
      <div class="pt-3 l-m-b-20 align-items-center d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <h1 class="w-full">Phone numbers</h1>
          <div class="input-group search">
            <button type="button" class="btn input-group-btn" @click="clearSearch">
              <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
            </button>
            <input class="form-control" type="text" v-model="q" @keyup="searchText($event)"
                   placeholder="Search"
            />
          </div>
        </div>
        <div class="text-right d-flex new-twil">
          <div v-if="$_can('twilio-subaccount.suspend') || $_can('twilio-subaccount.close')"
               class="dropdown dropdown-menu-right pr-3"
          >
            <button class="btn btn-select twilio-btn" type="button" id="dropdownMenuButton"
                    data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false"
            >
              <img src="../../assets/img/twilio-logo-red.svg" class="twilio-logo-red" />
            </button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
              <div v-if="$_can('twilio-subaccount.suspend')" class="dropdown-box border-bottom pointer"
                   @click="suspendTwilioAccount"
              >
                <button class="dropdown-item">
                  Suspend Twillio
                </button>
                <p>You can enable it any time and continue using phone numbers you've already purchased</p>
              </div>
              <div v-if="$_can('twilio-subaccount.close')" class="dropdown-box pointer" @click="closeTwilio = true">
                <button class="dropdown-item">
                  Close Twillio
                </button>
                <p>
                  You will no longer be able to use services provided from twilio, your account will be suspended for
                  the time being
                </p>
              </div>
            </div>
          </div>
          <button class="btn btn-primary" @click="showCreateModal = true" v-if="$_can('phone-numbers.store')">
            ADD PHONE NUMBER
          </button>
        </div>
      </div>
    </div>
    <div v-else class="blocks">
      <div v-if="$_can('twilio-subaccount.store')">
        <div class="row py-3 l-m-b-20 mx-1 bg-light">
          <div class="col-2 py-2 text-right icon-twilio">
            <div class="icon-wrap">
              <span class="mod-icon-twillio-red" />
            </div>
          </div>
          <div class="col-6 py-2 border-left">
            <p>
              We’re obsessed with the security of customer data. I’d bet you are too. One of the most commonly
              requested
              features from customers delivering sensitive information via SMS is the ability to redact the message
              bodies
              before they’re stored.
            </p>
            <p>
              We’re thrilled to announce Message Body Redaction for Programmable SMS is now available in Developer
              Preview.
              With this new feature, developers can take even more control over the privacy of their customers’ data.
            </p>
            <button class="btn btn-primary mb-2" @click="enableTwilioAccount" v-if="twilioStatus === 'suspended'">
              Reactivate twilio
            </button>
            <button class="btn btn-primary mb-2" @click="createTwilioAccount" v-else>Enable twilio</button>
            <error-field :errors="errors" field="twilio" />
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row py-3 l-m-b-20 mx-1 bg-light">
          <div class="col-2 py-2 text-right icon-twilio">
            <div class="icon-wrap">
              <span class="mod-icon-twillio-red" />
            </div>
          </div>
          <div class="col-6 py-2 border-left">
            <p>
              Twilio subaccount is managed by your cluster administrator, it was suspended or wasn’t created yet.
              Please contact them for further inquires.
            </p>
          </div>
        </div>
      </div>
    </div>

    <template v-if="!phoneNumbers">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template v-else>
      <div v-if="twilioStatus === 'active' && $_can('phone-numbers.index')">
        <div class="blocks">
          <SettingsPhoneNumbersBlock
            v-for="(phone, index) in phoneNumbers"
            :key="index"
            :phone.sync="phone"
            @openEditModal="openEditModal(phone)"
          />
        </div>

        <div class="row blocks">
          <div class="col-md-6 mb-1 text-black-50 pl-0"
               v-if="meta.total"
          >
            Showing {{ meta.from }} - {{ meta.to }} of {{ meta.total }}
          </div>
          <pagination class="col-md-6 mb-1 pr-0" :change-page="changePage" :meta="meta" />
        </div>
      </div>
    </template>

    <!--Create-->
    <modal v-if="showCreateModal" @close="closeModal" size="modal-large">
      <div slot="header">
        <h4>Choose A Phone Number</h4>
      </div>
      <div slot="body">
        <p>
          You can get a phone number for your company that will allow you to send and receive messages. Mod24 will
          cover the expenses.
        </p>
        <template v-if="step === 1">
          <div class="row">
            <div class="col">
              <p>Enter the location or area code in which you want to find a phone number.</p>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col">
              <div class="select-wrap">
                <label>Filter by</label>
                <simple-select v-model="filterBy"
                               :options="filterOptions"
                               placeholder="Select"
                />
              </div>
            </div>
            <div class="col">
              <div class="select-wrap">
                <label>Value</label>
                <input v-model="value" class="form-control" type="text" />
              </div>
              <error-field :errors="errors" field="value" />
            </div>
          </div>
          <div class="row m-0">
            <div class="col-12">
              <button type="button" class="btn btn-primary pull-right ld-ext-right"
                      :class="loadingButton ? 'running' : ''"
                      :disabled="buttonDisabled"
                      @click="find"
              >
                Search
                <div class="ld ld-ball ld-flip" />
              </button>
            </div>
          </div>
        </template>

        <template v-if="step === 2">
          <button class="btn btn-primary mb-2" @click="step = 1">Go back</button>
          <div class="phone-number-modal">
            <table class="table m-table table-hover" style="max-height: 80vh; overflow: auto;">
              <thead>
                <tr class="m-table__heading">
                  <th>Phone number</th>
                  <th>Location</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="phone in availablePhones"
                    :key="phone.id"
                    @click="selectNumber(phone)"
                >
                  <td>{{ phone.friendlyName }}</td>
                  <td>{{ phone.region }}, {{ phone.locality }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>

        <template v-if="step === 3">
          <div class="mb-2">
            <div class="col">
              {{ phone.friendlyName }} -
              {{ phone.region }}, {{ phone.locality }}
            </div>
          </div>
          <div class="row no-gutters">
            <div class="col">
              <button class="btn btn-primary" @click="step = 2">Go back to search results</button>
            </div>
            <div class="col text-right">
              <button @click="save(phone)" class="btn btn-primary">Get this phone</button>
            </div>
          </div>
        </template>
      </div>
      <div slot="footer" />
    </modal>
    <!--Edit-->
    <modal v-if="showEditModal" @close="closeModal" size="modal-large">
      <div slot="header">
        <h4 v-if="!editPhone.type || editPhone.type.id === ''">Select type</h4>
        <h4 v-else-if="editPhone.type.id === 1">Select type and company</h4>
        <h4 v-else-if="editPhone.type.id === 2">Select type and carrier</h4>
      </div>
      <div slot="body">
        <div class="row">
          <div class="col pr-1">
            <div class="select-wrap">
              <label>Phone</label>
              <div class="form-control">{{ phoneMask.maskedPhone(editPhone.phone_number) }}</div>
            </div>
          </div>
          <div class="col pl-1">
            <div class="select-wrap">
              <label>Type</label>
              <simple-select v-model="editPhone.type.id"
                             :options="phoneTypeOptions"
                             placeholder="Select"
              />
            </div>
            <error-field :errors="errors" field="type_id" />
          </div>
          <div class="col px-1" v-if="editPhone.type.id === 1">
            <div class="select-wrap">
              <label>Company</label>
              <simple-select v-model="editPhone.company.id"
                             :options="companies"
                             placeholder="Select"
              />
            </div>
            <error-field :errors="errors" field="company_id" />
          </div>
          <div class="col px-1" v-if="editPhone.type.id === 2">
            <div class="select-wrap">
              <label>Carrier</label>
              <simple-select v-model="editPhone.carrier.id"
                             :options="carriers"
                             placeholder="Select"
              />
            </div>
            <error-field :errors="errors" field="carrier_id" />
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col text-right">
            <button class="btn btn-secondary" @click="deleteNumber" v-if="$_can('phone-numbers.destroy')">Delete</button>
            <button class="btn btn-primary" @click="edit" v-if="$_can('phone-numbers.store')">Save</button>
          </div>
        </div>
      </div>
    </modal>

    <!--Close Twilio-->
    <modal v-if="closeTwilio" @close="closeModal" size="modal-large">
      <div slot="header">
        <h4>Close Twilio</h4>
      </div>
      <div slot="body">
        <div class="row">
          <div class="col">
            <p>
              You will no longer be able to use services provided from twilio, your account will be suspended for the
              time being
            </p>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col text-right">
            <button class="btn btn-secondary" @click="closeModal">Cancel</button>
            <button class="btn btn-primary" @click="closeTwilioAccount">Close Twilio</button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import { mapState } from 'vuex';
import Modal from '../Modal';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';
import PhoneMask from '../../classes/PhoneMask';
import SettingsPhoneNumbersBlock from './SettingsPhoneNumbersBlock';
import Pagination from '../Pagination';

export default {
  name: 'PhoneNumbers',
  components: {
    SettingsPhoneNumbersBlock,
    Modal,
    ErrorField,
    Pagination,
  },
  data: () => ({
    filterBy: 'area-code',
    value: '',
    phoneNumbers: null,
    meta: [],
    page: 1,
    phone: '',
    editPhone: {
      carrier: { id: '' },
      company: { id: '' },
      type: { id: '' },
    },
    phoneTypeOptions: [],
    availablePhones: [],
    showCreateModal: false,
    showEditModal: false,
    closeTwilio: false,
    step: 1,
    filterOptions: [
      {
        id: 'area-code',
        name: 'area-code',
      },
      {
        id: 'state',
        name: 'state',
      },
      {
        id: 'location',
        name: 'location',
      },
    ],
    twilioStatus: null,
    loadingButton: false,
    buttonDisabled: false,
    phoneMask: new PhoneMask(),
    q: '',
    errors: new Errors(),
  }),
  computed: {
    ...mapState({
      carriers: state => state.carriers.carriers.data,
      companies: state => state.companies.companies.data,
    }),
  },
  mounted() {
    this.getNumbers();
    this.getTypes();
    this.getTwilioAccount();
  },
  methods: {
    getNumbers() {
      axios
        .get(`/phone-numbers?q=${this.q}`)
        .then(res => {
          this.phoneNumbers = res.data.data;
          this.meta = res.data.meta;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    changePage(pageNum) {
      this.phoneNumbers = [];
      this.page = pageNum;
      this.filter(pageNum);
    },
    filter(pageNum) {
      axios
        .get(`/phone-numbers?page=${pageNum}&q=${this.q}?`)
        .then(res => {
          this.phoneNumbers = res.data.data;
          this.meta = res.data.meta;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    searchText(e) {
      if (/^[a-zA-Z0-9]$/.test(e.key) || e.keyCode === 8 || e.keyCode === 13) {
        const vm = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          vm.getNumbers();
        }, 500);
      }
    },
    getTypes() {
      axios
        .get(`/values/phone-number-types`)
        .then(res => {
          this.phoneTypeOptions = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    clearSearch() {
      this.q = '';
      this.getNumbers();
    },
    find() {
      this.buttonDisabled = true;
      this.loadingButton = true;
      axios
        .get(`/phone-numbers/find-available?filter-by=${this.filterBy}&value=${this.value}`)
        .then(res => {
          this.availablePhones = res.data;
          this.step = 2;
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    selectNumber(phone) {
      this.phone = phone;
      this.step = 3;
    },
    save() {
      axios
        .post('/phone-numbers', {
          phone_number: this.phone.phoneNumber,
          phone_number_type_id: 1,
        })
        .then(res => {
          this.phoneNumbers.push(res.data.data);
          toastr.success('Phone saved');
          this.showCreateModal = false;
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.step = 1;
          this.value = '';
          this.filterBy = 'area-code';
        });
    },
    openEditModal(phone) {
      this.showEditModal = true;
      this.editPhone = phone;
      if (!this.editPhone.company) {
        this.editPhone.company = { id: '' };
      }
      if (!this.editPhone.carrier) {
        this.editPhone.carrier = { id: '' };
      }
      if (!this.editPhone.type) {
        this.editPhone.type = { id: '' };
      }
    },
    edit() {
      let url = `/phone-numbers/company/assign`;
      let data = {};
      if (this.editPhone.type.id === 1) {
        data = {
          company_id: this.editPhone.company.id,
          phone_number_id: this.editPhone.id,
        };
      } else {
        url = `/phone-numbers/carrier/assign`;
        data = {
          carrier_id: this.editPhone.carrier.id,
          phone_number_id: this.editPhone.id,
        };
      }
      axios
        .put(url, data)
        .then(res => {
          const index = this.phoneNumbers.findIndex(number => number.id === res.data.data.id);
          this.phoneNumbers[index] = res.data.data;
          this.showEditModal = false;
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    deleteNumber() {
      axios
        .delete(`/phone-numbers/${this.editPhone.id}`)
        .then(() => {
          this.getNumbers();
          this.closeModal();
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
          if (this.errors.has('exception')) {
            toastr.error('An error occurred');
          }
        });
    },
    closeModal() {
      this.showCreateModal = false;
      this.showEditModal = false;
      this.step = 1;
      this.editPhone = {};
      this.closeTwilio = false;
    },
    getTwilioAccount() {
      this.errors.clear();
      const url = this.$_can('twilio-subaccount.show')
        ? `/twilio-subaccount`
        : `/twilio-subaccount/status`;
      axios
        .get(url)
        .then(res => {
          this.twilioStatus = res.data.data.status;
        })
        .catch(err => {
          this.errors.record(err.response.data);
          this.twilioStatus = 'no-account';
        });
    },
    createTwilioAccount() {
      this.errors.clear();
      axios
        .post(`/twilio-subaccount`)
        .then(() => {
          toastr.success('Account created');
          this.getTwilioAccount();
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    enableTwilioAccount() {
      this.errors.clear();
      axios
        .get(`/twilio-subaccount/reactivate`)
        .then(res => {
          this.twilioStatus = res.data.data.status;
          this.getNumbers();
          toastr.success('Account enabled');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    suspendTwilioAccount() {
      axios
        .get(`/twilio-subaccount/suspend`)
        .then(res => {
          this.twilioStatus = res.data.data.status;
          toastr.success('Account suspended');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    closeTwilioAccount() {
      axios
        .delete(`/twilio-subaccount/close`)
        .then(() => {
          this.getNumbers();
          toastr.success('Account closed');
          this.twilioStatus = '';
        })
        .catch(err => {
          toastr.error(`Account doesn't exist`);
          this.errors.record(err.response.data.error);
        });
      this.closeModal();
    },
  },
};
</script>
<style lang="scss" scoped>
.w-full {
  width: 400px;
}
.twilio-btn {
  width: 110px;
  background: #fff;
}
.twilio-logo-red {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/SettingsPhoneNumbers.vue